import React from "react";
import { Box, Progress, Stack, Text, Flex } from "@chakra-ui/react";
import useReportData from "../../../hooks/useReportData";

const ReportProgressWidget = ({ funds }) => {
  const { reportGeneration } = useReportData(funds);

  return (
    <Flex direction="column" gap={8}>
      <h5 mb={4}>Report Generation Progress</h5>
      <Stack spacing={4}>
        {Object.entries(reportGeneration).map(([category, data], index) => (
          <Box key={index}>
            <Flex alignItems="center" gap={2} mb={2}>
              <Text fontWeight="bold" color={"grey.700"}>
                {category}
              </Text>
              <Text>
                {data.total - data.overdue}/{data.total} Generated
              </Text>
            </Flex>
            <Progress
              value={((data.total - data.overdue) / data.total) * 100}
              colorScheme="green"
              h={"24px"}
              borderRadius="md"
              hasStripe
              isAnimated
            />
          </Box>
        ))}
      </Stack>
    </Flex>
  );
};

export default ReportProgressWidget;
